// extracted by extract-css-chunks-webpack-plugin
module.exports = {"AVATAR_SIZE":"80px","authorImageContainer":"_3V7PSR","image":"_3-Hy2k","imageWrapper":"_1BnWUP"};